<template>
  <div class="writeDoc content-item flex align-items-center">
    <div class="content-item-label"><span class="red" v-if="JSON.parse(commonData[0].value)==='1'">*</span>{{ JSON.parse(commonData[1].value) }}</div>
    
    <el-select
      v-model="value"
      placeholder="请选择"
      size="mini"
      class="selectBus"
      @change="$emit('petEffect', {value: value, list: petClassifyList})"
      multiple
    >
      <el-option
        v-for="item in petClassifyList"
        :key="item.id"
        :label="item.desc"
        :value="item.code"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { request } from "@/utils/axios";
export default {
  name: "PetEffect",
  props: ["commonData", "petEffectCode"],
  data() {
    return {
      petClassifyList: [],
      value:[]
    }
  },
  created() {
    this.queryClassify();
  },
  methods: {
    // 回显数据
    setPetClassifyCheckList (data) {
      this.value = data;
    },
    // 获取宠物分类信息
    queryClassify() {
      request("health_cmp_queryDictionaries",{
        typeList: [40]
      }).then(res => {
        this.petClassifyList = res || []
      }).catch(err => {
        this.petClassifyList = []
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.red{
  color: #f62458;
	margin-right: 5px;
}

</style>
